export const MISSING_INFORMATION = 'missing_information';
export const UNBALANCED_SHARES_NUMBER = 'unbalanced_shares_number';
